<template >
  <div >
    <el-upload

        style="background-color: #9bf8f1;color: #042e2a;box-shadow: 0px 0px 2px;border-radius: 3px;margin: 1px"
        :data="uploadParams"
        action="/assets/components/travel/connector.php"

        :on-success="goProcessFile" >
      <i class="el-icon-upload" ></i >
      <div
          class="el-upload__text"
          v-html="placeholder"  style="background-color: #9bf8f1;color: #042e2a">

      </div >
      <!-- <div class="el-upload__tip" slot="tip">jpg/png files with a size less than 500kb</div> -->
    </el-upload >

  </div >
</template >

<script >
export default {
  name: "FileUploader",
  props: {
    placeholder: {type: String, default: ' drop file here <em >or click to select</em >'},
    processor: {type: String, default: null},
    reqParams: {type: Object, default: () => null}
  },
  methods: {
    goProcessFile(file_res) {
      _log_('file_res', file_res)
      this.$emit('uploaded', file_res)
    }
  },
  computed: {
    uploadParams() {
      const mPrms = {
        HTTP_MODAUTH: window.Travel.auth,
        ctx: "web",
        action: this.processor,
      }
      return this.reqParams ? {...mPrms, ...this.reqParams} : mPrms
    }
  },
  data() {
    return {
      lastUploadedFileId: null,
      proccessErrors: null,
      clock: 0,
      // mainUploadParams: {//
      //   HTTP_MODAUTH: window.Travel.auth,
      //   ctx: "web",
      //   action: "reservations/files/import",
      // },

    };
  },
}
</script >

<style >
.el-upload__text {
  color: white
}
</style >
